import { isNil, orderBy } from 'lodash/fp';
import { translate } from '../../../../utils';
import { HeadCell, Ordering } from '../../../../ui-kit/Table/types';
import { PriceService } from '../../../../services';
import { CurrencyCode } from '../../../../server-types';
import { OrderColumn, Row, RowData, TableStatistics, TablesStatistics } from './types';

export const headCells: Array<HeadCell<Row>> = [
    { id: 'name', align: 'left', label: translate('Table Name') },
    { id: 'billCount', align: 'right', label: translate('Bill Count') },
    { id: 'averageBill', align: 'right', label: translate('Average Bill') },
    { id: 'grossRevenue', align: 'right', label: translate('Gross Revenue') },
];

export const getTableDataMaps = (
    rowData: TablesStatistics,
    priceService: PriceService,
    currencyCode: CurrencyCode,
): { sectionsRowData: RowData[]; placeSectionMap: Record<string, RowData[]> } => {
    const sectionsMap: Record<string, TableStatistics> = {};
    const placeSectionMap: Record<string, RowData[]> = {};
    rowData.forEach(item => {
        const { id, sectionId, sectionName, placeName, billCount, grossRevenue } = item;
        if (!sectionsMap[sectionId]) {
            sectionsMap[sectionId] = { billCount: 0, grossRevenue: null, id: sectionId, placeName: sectionName, sectionName, sectionId };
        }

        if (!placeSectionMap[sectionId]) {
            placeSectionMap[sectionId] = [];
        }
        const billCountAcc = sectionsMap[sectionId].billCount + billCount;
        let grossRevenueAcc = sectionsMap[sectionId].grossRevenue;
        let averageBill: null | undefined | number;

        if (grossRevenue && billCount !== 0) {
            grossRevenueAcc = grossRevenue + (grossRevenueAcc || 0);
            averageBill = priceService.divide(grossRevenue, billCount, currencyCode);

        }

        sectionsMap[sectionId].billCount = billCountAcc;
        sectionsMap[sectionId].grossRevenue = grossRevenueAcc;

        const placeRowData: RowData = {
            id,
            name: placeName,
            grossRevenue,
            averageBill,
            billCount,
        };

        placeSectionMap[sectionId].push(placeRowData);
    });

    const sections = Object.values(sectionsMap);
    const sectionsRowData = sections.map(({ grossRevenue, billCount, id, placeName }) => {
        let averageBill: null | undefined | number;
        if (grossRevenue && billCount !== 0) {
            averageBill = priceService.divide(grossRevenue, billCount, currencyCode);
        }
        const row: RowData = {
            id,
            name: placeName,
            billCount,
            grossRevenue,
            averageBill,
        };
        return row;
    });

    return { sectionsRowData, placeSectionMap };
};

export const getSortFunction = (finalOrderDirection: Ordering, finalOrderingColumn: OrderColumn) => orderBy<RowData>(item => {
    const { [finalOrderingColumn]: orderColumn } = item;
    if (isNil(orderColumn)) {
        return finalOrderDirection === 'asc' ? 999999999 : -999999999;
    }
    return orderColumn;

}, finalOrderDirection);